import { IconsProps } from '@/types/shared'
import React from 'react'

const PdfIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="none"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.63688 15.5813C2.94932 15.8938 3.32492 16.05 3.76367 16.05H16.5273C16.9661 16.05 17.3417 15.8938 17.6541 15.5813C17.9665 15.2689 18.1228 14.8933 18.1228 14.4546V4.88183C18.1228 4.44308 17.9665 4.06748 17.6541 3.75504C17.3417 3.4426 16.9661 3.28638 16.5273 3.28638H3.76367C3.32492 3.28638 2.94932 3.4426 2.63688 3.75504C2.32443 4.06748 2.16821 4.44308 2.16821 4.88183V14.4546C2.16821 14.8933 2.32443 15.2689 2.63688 15.5813ZM4.56139 12.8591H5.67821V10.6255H6.79503C7.11146 10.6255 7.3767 10.5184 7.59076 10.3044C7.80482 10.0903 7.91185 9.82507 7.91185 9.50864V8.39182C7.91185 8.07539 7.80482 7.81015 7.59076 7.59609C7.3767 7.38203 7.11146 7.275 6.79503 7.275H4.56139V12.8591ZM5.67821 8.39182V9.50864H6.79503V8.39182H5.67821ZM14.6128 12.8591H13.4959V7.275H15.7296V8.39182H14.6128V9.50864H15.7296V10.6255H14.6128V12.8591ZM9.02866 12.8591V7.275H11.2623C11.5787 7.275 11.844 7.38203 12.058 7.59609C12.2721 7.81015 12.3791 8.07539 12.3791 8.39182V11.7423C12.3791 12.0587 12.2721 12.324 12.058 12.538C11.844 12.7521 11.5787 12.8591 11.2623 12.8591H9.02866ZM10.1455 11.7423V8.39182H11.2623V11.7423H10.1455Z"
                    fill="#EA4336"
                />
            </svg>
        </div>
    )
}

export default PdfIcons
